module.exports = __webpack_public_path__ + "static/ville-bruxelles-92ad22018beeeb5e30f5c62054b8cde7.png";